import { Tooltip } from "antd";

const Filter = (props) => {
  const { menu, icon, titleEng, titleArabic, tooltiptextEng, tooltiptextArab } =
    props;

  return (
    <div className="filter-item">
      {/* top row: icon + titles */}
      <div className="filter-head">
        <Tooltip
          placement="bottom"
          title={
            <>
              <span className="tooltip-ar">{tooltiptextArab}</span>
              <br />
              <span className="tooltip-en">{tooltiptextEng}</span>
            </>
          }
          overlayClassName="filter-toolkit"
        >
          <div className="icon-cell">
            <div className="filter-icon">{icon}</div>
          </div>
        </Tooltip>

        <div className="filter-titles">
          <div className="title-ar">{titleArabic}</div>
          <div className="title-en">{titleEng}</div>
        </div>
      </div>

      {/* column body: menu list always visible */}
      <div className="filter-dropdown" onClick={(e) => e.preventDefault()}>
        {menu}
      </div>
    </div>
  );
};

export default Filter;
